import { Card } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function AuthorizerComment({ value }) {
  const { t } = useTranslation();
  const sortedValues = [...value].sort((a, b) => b.trackId - a.trackId);
  const [showGridAccount, setShowGridAccount] = useState("GRID");

  useEffect(() => {
    if (window.innerWidth < 900) {
      setShowGridAccount("LIST");
    }
  }, [window.innerWidth]);
  return (
    <div>
      {showGridAccount === "GRID" && (
        <div className="ft-table">
          <table className="table">
            <thead style={{ backgroundColor: "#F1F1F1" }}>
              <tr>
                <th>
                  {t("pages.pending_approval.authorizer_name", {
                    defaultValue: "User Name",
                  })}
                </th>
                <th>
                  {t("pages.pending_approval.authorizer_type", {
                    defaultValue: "Role Type",
                  })}
                </th>
                <th>
                  {t("pages.common.comments", {
                    defaultValue: "Reason",
                  })}
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedValues.map((ele, idx) => (
                <tr key={idx}>
                  <td>{ele.userName}</td>
                  <td>
                    {ele?.userRole === "A"
                      ? t("pages.pending_approval.authorser", {
                          defaultValue: "Authorizer",
                        })
                      : ele?.userRole === "I"
                      ? t("pages.pending_approval.initiator", {
                          defaultValue: "Initiator",
                        })
                      : t("pages.pending_approval.verifier", {
                          defaultValue: "Verifier",
                        })}
                  </td>
                  <td
                    style={{
                      whiteSpace: "break-spaces",
                      wordBreak: "break-all",
                    }}
                  >
                    {ele?.comment || "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {showGridAccount === "LIST" && (
        <div>
          {sortedValues.map((ele, idx) => (
            <div key={idx}>
              <div className="account-row-data list-row mb-2">
                <div>
                  <div>{ele.userName}</div>
                  <div>
                    {ele?.userRole === "A"
                      ? t("pages.pending_approval.authorser", {
                          defaultValue: "Authorizer",
                        })
                      : ele?.userRole === "I"
                      ? t("pages.pending_approval.initiator", {
                          defaultValue: "Initiator",
                        })
                      : t("pages.pending_approval.verifier", {
                          defaultValue: "Verifier",
                        })}
                  </div>
                </div>
                <div align="right">
                  <div
                    style={{
                      whiteSpace: "break-spaces",
                      wordBreak: "break-all",
                    }}
                  >
                    {ele?.comment || "-"}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
